<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  created() {
    console.log("env", process.env)
    this.$store.dispatch('setting/init')
  },
  updated() {
    window.addEventListener('unload', this.saveState)
    document.body.ondragstart = null
  },
  methods: {
    saveState() {
      sessionStorage.setItem('state', JSON.stringify(this.$store.state))
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function() {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style>
/* 来电弹窗样式覆盖（如其他地方用到 Notification 可保留） */
.video-call-notify {
  width: 340px !important;
}
.video-call-notify .el-notification__content {
  padding: 4px 0 0 0;
}
</style>
